import { Component } from '@angular/core';
import { MatterDocumentType, MatterFile } from '@models/matter-file';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterUploadedFilesDispatch } from '@state/matter/uploaded-files/matter-uploaded-files.dispatch';
import { MatterUploadedFilesSelectors } from '@state/matter/uploaded-files/matter-uploaded-files.selectors';
import { TestHooks } from './fire-insurance.hooks';

@Component({
	selector: 'app-fire-insurance',
	templateUrl: './fire-insurance.component.html',
	styleUrls: ['./fire-insurance.component.scss'],
	standalone: false,
})
export class FireInsuranceComponent {
	testHooks = TestHooks;
	public fileType = MatterDocumentType.FIRE_INSURANCE;
	public fileName = 'FIRE_INSURANCE';
	@ViewSelectSnapshot(MatterUploadedFilesSelectors.getLatestFireInsurance)
	latestDoc: MatterFile;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private matterUploadedFilesDispatch: MatterUploadedFilesDispatch,
	) {}

	delete(): void {
		this.matterUploadedFilesDispatch.Delete(this.latestDoc.id);
	}
}
